import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/**
 * Узел дерева справочников
 */
let PitNciRegistryTreeNode = class PitNciRegistryTreeNode {
    getItemId() {
        return this._id;
    }
    getParentItemId() {
        return this._parentId;
    }
    setParentItemId(value) {
        this._parentId = value;
    }
    getItemType() {
        return this._type;
    }
    setItemType(value) {
        this._type = value;
    }
    getItemOrd() {
        return this._ord;
    }
    getItemTitle() {
        return this._title;
    }
    getItemIdent() {
        return this._ident;
    }
    getItemIcon() {
        return "";
    }
    getItemDescription() {
        return this._description;
    }
    getItemSearchString() {
        return "";
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get parentId() {
        return this._parentId;
    }
    set parentId(value) {
        this._parentId = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get dictionaryIdent() {
        return this._dictionaryIdent;
    }
    set dictionaryIdent(value) {
        this._dictionaryIdent = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNciRegistryTreeNode.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNciRegistryTreeNode.prototype, "_parentId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNciRegistryTreeNode.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNciRegistryTreeNode.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNciRegistryTreeNode.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNciRegistryTreeNode.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNciRegistryTreeNode.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "dictionaryIdent", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNciRegistryTreeNode.prototype, "_dictionaryIdent", void 0);
PitNciRegistryTreeNode = tslib_1.__decorate([
    jsonObject
], PitNciRegistryTreeNode);
export { PitNciRegistryTreeNode };
